export enum ImageSettingsActionListEnum {
  CHANGE_IMAGE_TYPE = 'imageSettings:imageType:change',
  RESET_IMAGE_SETTINGS = 'imageSettings:reset',
  TOGGLE_DOUBLE_PAGE = 'textSettings:isDoublePage:toggle',
  CHANGE_INDENT_RED_LINE = 'textSettings:indentRedLine:change',
  CHANGE_INDENT_RIGHT = 'textSettings:indentRight:change',
  CHANGE_INDENT_LEFT = 'textSettings:indentLeft:change',
  CHANGE_INDENT_TOP = 'textSettings:indentTop:change',
}
